export const DEFAULT_INTEREST = 0.07;
export const DEFAULT_CREDIT_DURATION_YEARS = 30;
export const DEFAULT_INTEREST = 0.07;
export const DEFAULT_CREDIT_DURATION_YEARS = 30;
